import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, toHandlers as _toHandlers, createSlots as _createSlots, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-efd1e46e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"width":"100%"}
}
const _hoisted_2 = {
  class: "cm-required",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_3 = {
  key: 0,
  class: "gap-x-4",
  style: {"display":"flex","align-items":"center","flex":"1"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-info" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "cm-label"
}
const _hoisted_6 = {
  class: "",
  style: {"width":"100%","box-sizing":"border-box"}
}
const _hoisted_7 = {
  key: 0,
  style: {"line-height":"1rem","font-size":"14px","color":"var(--cm-color-text-regular)"}
}
const _hoisted_8 = {
  class: "",
  style: {"background":"transparent"}
}

import { getFormItemRules, getLabel, getValue } from '@/hooks'
import { computed, PropType } from 'vue'
import { ActionType, FormType, FormItem, GlobalOpt } from './types'
import { useCmFormDefaultPlaceholder } from './useCmFormDefaultPlaceholder'

export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicFormItem',
  props: {
  dynamicFormItem: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: Object,
    required: true,
  },
  prop: {
    type: String,
    required: true,
  },
  globalOpt: {
    type: Object as PropType<GlobalOpt>,
    default: () => ({}),
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const { placeholderInput: phInput, placeholderSelect: phSelect } =
  useCmFormDefaultPlaceholder()
/** 模板内不宜写 TS 断言，统一在此收窄类型 */
function placeholderInput(fi: object) {
  return phInput(fi as FormItem<any, any>)
}
function placeholderSelect(fi: object) {
  return phSelect(fi as FormItem<any, any>)
}
const form = computed({
  get: () => props.modelValue,
  set: (val: any) => emit('update:modelValue', val),
})
const getIndex = computed(
  () => (key: number | string, formItemIndex: number | undefined) =>
    (Array.isArray(props.dynamicFormItem?.columns) && formItemIndex) || key,
)
const getKey = computed(
  () => (key: number | string, formItem: { prop?: string }) =>
    (Array.isArray(props.dynamicFormItem?.columns) && formItem.prop) || key,
)
const maxShow = computed(
  () => props.dynamicFormItem?.maxCount <= form.value?.[props.prop]?.length,
)
const leastShow = computed(
  () => props.dynamicFormItem?.leastCount >= form.value?.[props.prop].length,
)
const handle = (type: string, index?: number, row?: any): void => {
  const types: any = {
    [ActionType.Add]: () =>
      props.dynamicFormItem.rowAdd((row: any) =>
        form.value?.[props.prop].push(row),
      ),
    [ActionType.Delete]: (index: number) =>
      props.dynamicFormItem.rowDel(row, () =>
        form.value?.[props.prop].splice(index, 1),
      ),
  }
  types[type](index, row)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_segmented = _resolveComponent("el-segmented")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { justify: "start" }, {
      default: _withCtx(() => [
        (!__props.dynamicFormItem.hiddenPlusBtn)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              icon: "el-icon-plus",
              circle: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handle(_unref(ActionType).Add))),
              disabled: __props.dynamicFormItem.disabledPlusBtn ?? maxShow.value,
              style: {"margin-bottom":"10px"}
            }, null, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "plus")
      ]),
      _: 3
    }),
    _createVNode(_component_el_row, {
      class: "gap-10",
      style: {"flex-direction":"column"}
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value[__props.prop], (item, index) => {
          return (_openBlock(), _createBlock(_component_el_row, _mergeProps({
            key: index,
            gutter: 10,
            class: "item-hover",
            ref_for: true
          }, { ...__props.globalOpt?.rowOpt, ...item.rowOpt }), {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dynamicFormItem.columns, (formItem, key, formIndex) => {
                return (_openBlock(), _createBlock(_component_el_col, _mergeProps({
                  key: getIndex.value(key, formIndex),
                  style: {"margin-bottom":"20px"},
                  ref_for: true
                }, { ...__props.globalOpt?.colOpt, ...formItem.colOpt }), {
                  default: _withCtx(() => [
                    (!formItem.hidden?.())
                      ? (_openBlock(), _createBlock(_component_el_form_item, _mergeProps({
                          key: 0,
                          prop: `${__props.prop}.${index}.${getKey.value(key, formItem)}`,
                          rules: _unref(getFormItemRules)(__props.globalOpt?.required, formItem),
                          ref_for: true
                        }, formItem.formItemOpt), {
                          label: _withCtx(() => [
                            (!formItem.hiddenAllLabel)
                              ? _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-label', {
                                  key: 0,
                                  formItem: formItem,
                                  formItemIndex: getIndex.value(key, formIndex),
                                  formIndex: getIndex.value(key, formIndex)
                                }, () => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _renderSlot(_ctx.$slots, formItem.prop + '-label', {
                                      formItem: formItem,
                                      label: formItem.label,
                                      prop: formItem.prop
                                    }, () => [
                                      (!formItem.hiddenAllLabel)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            (formItem.tip)
                                              ? (_openBlock(), _createBlock(_component_el_tooltip, _mergeProps({
                                                  key: 0,
                                                  effect: "dark",
                                                  ref_for: true
                                                }, formItem.tipOpt, {
                                                  content: formItem.tip
                                                }), {
                                                  default: _withCtx(() => [
                                                    _hoisted_4
                                                  ]),
                                                  _: 2
                                                }, 1040, ["content"]))
                                              : _createCommentVNode("", true),
                                            (!formItem.hiddenLabel)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(formItem.label), 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-slot', {
                                prop: getKey.value(key, formItem),
                                formItem: formItem,
                                formItemIndex: getIndex.value(key, formIndex)
                              }, () => [
                                (!formItem.type)
                                  ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                      key: 0,
                                      modelModifiers: formItem.modelModifiers
                                    }, _toHandlers(formItem.events ?? {}), {
                                      type: formItem.inputType,
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      disabled: formItem.disabled?.(),
                                      placeholder: placeholderInput(formItem),
                                      ref_for: true
                                    }, formItem.inputOpt), _createSlots({ _: 2 }, [
                                      (formItem.prependSlot)
                                        ? {
                                            name: "prepend",
                                            fn: _withCtx(() => [
                                              _renderSlot(_ctx.$slots, "prepend")
                                            ]),
                                            key: "0"
                                          }
                                        : undefined,
                                      (formItem.appendSlot)
                                        ? {
                                            name: "append",
                                            fn: _withCtx(() => [
                                              _renderSlot(_ctx.$slots, "append")
                                            ]),
                                            key: "1"
                                          }
                                        : undefined
                                    ]), 1040, ["modelModifiers", "type", "modelValue", "onUpdate:modelValue", "disabled", "placeholder"]))
                                  : _createCommentVNode("", true),
                                (formItem.type === 'inputNumber')
                                  ? (_openBlock(), _createBlock(_component_el_input_number, _mergeProps({
                                      key: 1,
                                      modelModifiers: formItem.modelModifiers,
                                      placeholder: placeholderInput(formItem)
                                    }, _toHandlers(formItem.events ?? {}), {
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      disabled: formItem.disabled?.(),
                                      ref_for: true
                                    }, formItem.inputNumOpt), null, 16, ["modelModifiers", "placeholder", "modelValue", "onUpdate:modelValue", "disabled"]))
                                  : _createCommentVNode("", true),
                                (formItem.type === _unref(FormType).Cascader)
                                  ? (_openBlock(), _createBlock(_component_el_cascader, _mergeProps({
                                      key: 2,
                                      modelModifiers: formItem.modelModifiers,
                                      placeholder: placeholderSelect(formItem),
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      options: formItem.dictData,
                                      disabled: formItem.disabled?.(),
                                      props: formItem.props
                                    }, _toHandlers(formItem.events ?? {}), { ref_for: true }, formItem.cascaderOpt), null, 16, ["modelModifiers", "placeholder", "modelValue", "onUpdate:modelValue", "options", "disabled", "props"]))
                                  : _createCommentVNode("", true),
                                (formItem.type === _unref(FormType).Select)
                                  ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                                      key: 3,
                                      modelModifiers: formItem.modelModifiers
                                    }, _toHandlers(formItem.events ?? {}), {
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      disabled: formItem.disabled?.(),
                                      placeholder: placeholderSelect(formItem)
                                    }), {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItem.dictData, (opt) => {
                                          return (_openBlock(), _createBlock(_component_el_option, _mergeProps({
                                            modelModifiers: formItem.modelModifiers
                                          }, _toHandlers(opt.events ?? {}), {
                                            key: opt[_unref(getValue)(formItem.props)],
                                            disabled: opt.disabled,
                                            label: opt[_unref(getLabel)(formItem.props)],
                                            value: opt[_unref(getValue)(formItem.props)]
                                          }), null, 16, ["modelModifiers", "disabled", "label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1040, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled", "placeholder"]))
                                  : _createCommentVNode("", true),
                                (formItem.type === _unref(FormType).SelectGroup)
                                  ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                                      key: 4,
                                      modelModifiers: formItem.modelModifiers,
                                      ref_for: true
                                    }, formItem.selectGroupOpt, _toHandlers(formItem.events ?? {}), {
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      disabled: formItem.disabled?.(),
                                      placeholder: placeholderSelect(formItem)
                                    }), {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItem.dictData, (group) => {
                                          return (_openBlock(), _createBlock(_component_el_option_group, {
                                            key: group.label,
                                            label: group.label
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.dictData ?? group.dictData, (opt) => {
                                                return (_openBlock(), _createBlock(_component_el_option, _mergeProps({
                                                  modelModifiers: formItem.modelModifiers
                                                }, _toHandlers(opt.events ?? {}), { ref_for: true }, opt.opt, {
                                                  key: opt[_unref(getValue)(group.props)],
                                                  disabled: opt.disabled,
                                                  label: opt[_unref(getLabel)(group.props)],
                                                  value: opt[_unref(getValue)(group.props)]
                                                }), null, 16, ["modelModifiers", "disabled", "label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1040, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled", "placeholder"]))
                                  : _createCommentVNode("", true),
                                (formItem.type === _unref(FormType).Rate)
                                  ? (_openBlock(), _createBlock(_component_el_rate, _mergeProps({
                                      key: 5,
                                      modelModifiers: formItem.modelModifiers
                                    }, _toHandlers(formItem.events ?? {}), {
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      ref_for: true
                                    }, formItem.rateOpt, {
                                      disabled: formItem.disabled?.()
                                    }), null, 16, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled"]))
                                  : _createCommentVNode("", true),
                                (formItem.type === _unref(FormType).Date)
                                  ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                                      key: 6,
                                      modelModifiers: formItem.modelModifiers
                                    }, _toHandlers(formItem.events ?? {}), {
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      type: formItem.dateType || _unref(FormType).Date,
                                      "aria-label": `Pick a ${formItem.dateType || _unref(FormType).Date}`,
                                      placeholder: placeholderSelect(formItem),
                                      style: {"width":"100%"},
                                      ref_for: true
                                    }, formItem.dateOpt), null, 16, ["modelModifiers", "modelValue", "onUpdate:modelValue", "type", "aria-label", "placeholder"]))
                                  : _createCommentVNode("", true),
                                (formItem.type === _unref(FormType).Segmented)
                                  ? (_openBlock(), _createBlock(_component_el_segmented, _mergeProps({
                                      key: 7,
                                      modelModifiers: formItem.modelModifiers
                                    }, _toHandlers(formItem.events ?? {}), {
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      disabled: formItem.disabled?.(),
                                      options: formItem.options
                                    }), null, 16, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled", "options"]))
                                  : _createCommentVNode("", true),
                                (formItem.type === _unref(FormType).Time)
                                  ? (_openBlock(), _createBlock(_component_el_time_picker, _mergeProps({
                                      key: 8,
                                      modelModifiers: formItem.modelModifiers
                                    }, _toHandlers(formItem.events ?? {}), {
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      "aria-label": formItem.label,
                                      disabled: formItem.disabled?.(),
                                      placeholder: placeholderSelect(formItem),
                                      style: {"width":"100%"},
                                      ref_for: true
                                    }, formItem.timeOpt), null, 16, ["modelModifiers", "modelValue", "onUpdate:modelValue", "aria-label", "disabled", "placeholder"]))
                                  : _createCommentVNode("", true),
                                (formItem.type === _unref(FormType).Switch)
                                  ? (_openBlock(), _createBlock(_component_el_switch, _mergeProps({
                                      key: 9,
                                      modelModifiers: formItem.modelModifiers
                                    }, _toHandlers(formItem.events ?? {}), {
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      ref_for: true
                                    }, formItem.switchOpt, {
                                      disabled: formItem.disabled?.()
                                    }), null, 16, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled"]))
                                  : _createCommentVNode("", true),
                                (formItem.type === _unref(FormType).CheckboxGroup)
                                  ? (_openBlock(), _createBlock(_component_el_checkbox_group, _mergeProps({
                                      key: 10,
                                      modelModifiers: formItem.modelModifiers
                                    }, _toHandlers(formItem.events ?? {}), {
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      disabled: formItem.disabled?.(),
                                      ref_for: true
                                    }, formItem.checkboxGroupOpt), {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItem.dictData, (opt) => {
                                          return (_openBlock(), _createBlock(_component_el_checkbox, _mergeProps({
                                            modelModifiers: formItem.modelModifiers
                                          }, _toHandlers(opt.events ?? {}), {
                                            key: opt[_unref(getValue)(formItem.props)],
                                            disabled: opt.disabled,
                                            ref_for: true
                                          }, formItem.checkboxOpt, {
                                            value: opt[_unref(getValue)(formItem.props)],
                                            label: opt[_unref(getValue)(formItem.props)]
                                          }), {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(opt[_unref(getLabel)(formItem.props)]), 1)
                                            ]),
                                            _: 2
                                          }, 1040, ["modelModifiers", "disabled", "value", "label"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1040, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled"]))
                                  : _createCommentVNode("", true),
                                (formItem.type === _unref(FormType).Radio)
                                  ? (_openBlock(), _createBlock(_component_el_radio_group, _mergeProps({
                                      key: 11,
                                      modelModifiers: formItem.modelModifiers
                                    }, _toHandlers(formItem.events ?? {}), {
                                      modelValue: item[getKey.value(key, formItem)],
                                      "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                      disabled: formItem.disabled?.()
                                    }), {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItem.dictData, (opt) => {
                                          return (_openBlock(), _createBlock(_component_el_radio, _mergeProps({
                                            modelModifiers: formItem.modelModifiers
                                          }, _toHandlers(opt.events ?? {}), {
                                            key: opt[_unref(getValue)(formItem.props)],
                                            disabled: opt.disabled,
                                            label: opt[_unref(getValue)(formItem.props)],
                                            value: opt[_unref(getValue)(formItem.props)]
                                          }), {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(opt[_unref(getLabel)(formItem.props)]), 1)
                                            ]),
                                            _: 2
                                          }, 1040, ["modelModifiers", "disabled", "label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1040, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled"]))
                                  : _createCommentVNode("", true)
                              ]),
                              (formItem.tip)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(formItem.tip), 1))
                                : _createCommentVNode("", true),
                              _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-footer')
                            ])
                          ]),
                          _: 2
                        }, 1040, ["prop", "rules"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1040))
              }), 128)),
              _createVNode(_component_el_col, { span: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    icon: "el-icon-minus",
                    circle: "",
                    onClick: ($event: any) => (handle(_unref(ActionType).Delete, index, item)),
                    class: "remove-btn",
                    disabled: __props.dynamicFormItem.disabledRemoveBtn ?? leastShow.value
                  }, null, 8, ["onClick", "disabled"])
                ]),
                _: 2
              }, 1024),
              _renderSlot(_ctx.$slots, "footer", { index: index }, () => [
                _createVNode(_component_el_divider, { "content-position": "left" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, " 表单的第" + _toDisplayString(index + 1) + "项 ", 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            _: 2
          }, 1040))
        }), 128))
      ]),
      _: 3
    })
  ]))
}
}

})